import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { feedItems, feedCategories } from '@/mocks/home';

export default function FeedSection() {
  const [category, setCategory] = useState('全部');
  const list =
    category === '全部' ? feedItems : feedItems.filter((item) => item.category === category);

  return (
    <section id="feed" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <SectionHeading
          no="04"
          title="动态聚合"
          en="Live Feed"
          desc="封面驱动的动态流，按分区筛选，新料旧料混排在一起，一屏看完今天的更新。"
          right={
            <span className="hidden items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500 md:flex">
              <i className="ri-stack-line text-sm" />
              共 {list.length} 条
            </span>
          }
        />

        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="inline-flex flex-wrap items-center gap-1 rounded-full bg-background-200 px-1 py-1">
            {feedCategories.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setCategory(item)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  category === item
                    ? 'bg-foreground-950 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500 sm:hidden">
            <i className="ri-stack-line text-sm" />
            共 {list.length} 条
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {list.map((item) => (
            <a
              key={item.id}
              href="#submit"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <span className="relative block h-40 w-full overflow-hidden md:h-44">
                <img
                  src={item.img}
                  alt={`${item.title} - 黑料51黑料最新动态封面`}
                  title={`${item.title} 黑料51黑料动态`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-background-50/92 px-2 py-0.5 text-[11px] font-medium text-foreground-800">
                  {item.category}
                </span>
              </span>
              <span className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-[15px]">
                  {item.title}
                </h3>
                <span className="mt-auto flex items-center justify-between pt-4 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600">
                    <i className="ri-fire-line text-sm" />
                    {item.heat}
                  </span>
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}